/* 
 * This is not a list of *all* cps es programs -- this is just a list of
 * the CPS ES Programs that the requirement functions refer to.
 * */

// purely ES programs
// --------------------
export const BRADWELL_ES_PROGRAM = "609806-Open Enrollment";
export const CARTER_ES_PROGRAM = "609844-Open Enrollment";
export const CASALS_ES_PROGRAM = "610021-Open Enrollment";
export const CHALMERS_ES_PROGRAM = "609851-Open Enrollment";
export const CURTIS_ES_PROGRAM = "609900-Open Enrollment";
export const DENEEN_ES_PROGRAM = "609883-Open Enrollment";
export const DEWEY_ES_PROGRAM = "609885-Magnet Cluster";
export const DULLES_ES_PROGRAM = "610263-Open Enrollment";
export const DVORAK_ES_PROGRAM = "610254-Magnet Cluster (Technology)";

export const FULLER_ES_PROGRAM = "609928-Open Enrollment";
export const GRESHAM_ES_PROGRAM = "609955-Open Enrollment";
export const HARVARD_ES_PROGRAM = "609971-Open Enrollment";
export const HERZL_ES_PROGRAM = "609991-Open Enrollment";
export const HOWE_ES_PROGRAM = "610000-Open Enrollment";
export const JOHNSON_ES_PROGRAM = "610274-Open Enrollment";
export const LEWIS_ES_PROGRAM = "610036-Open Enrollment";

export const MARSH_ES_PROGRAM = "610054-Open Enrollment";
export const MARQUETTE_ES_PROGRAM = "610053-Magnet Cluster (International Baccalaureate Middle Years)";

export const MCNAIR_ES_PROGRAM = "610282-Open Enrollment";
export const MORTON_ES_PROGRAM = "610257-Open Enrollment";
export const NATIONAL_TEACHERS_ACADEMY_GENERAL_EDUCATION_ES_PROGRAM = "610231-General Education";
export const NATIONAL_TEACHERS_ACADEMY_REGIONAL_GIFTED_CENTER_ES_PROGRAM = "610231-Selective Enrollment (Regional Gifted Center)";

export const OKEEFFE_ES_PROGRAM = "610103-Open Enrollment";
export const PICCOLO_ES_PROGRAM = "610106-Open Enrollment";
export const SHERMAN_ES_PROGRAM = "610172-Open Enrollment";
export const STAGG_ES_PROGRAM = "610339-Open Enrollment";
export const TARKINGTON_ES_PROGRAM = "610396-Open Enrollment";
export const CHICAGO_ACADEMY_ES_PROGRAM = "610248-Open Enrollment";

export const BRENNEMANN_ES_PROGRAM = "610242-Magnet Cluster";
export const COURTENAY_ES_PROGRAM = "610355-Open Enrollment";
export const MCCUTCHEON_ES_PROGRAM = "610269-Open Enrollment";
export const CARNEGIE_MAGNET_CLUSTER_ES_PROGRAM = "609837-Magnet Cluster (International Baccalaureate Middle Years)";
export const CARNEGIE_OPEN_ENROLLMENT_ES_PROGRAM = "609837-Open Enrollment";
export const CARNEGIE_REGIONAL_GIFTED_CENTER_ES_PROGRAM = "609837-Selective Enrollment (Regional Gifted Center)";

export const ALCOTT_ES_PROGRAM = "609774-Open Enrollment";
export const BOONE_ES_PROGRAM = "609804-Magnet Cluster";
export const FIELD_ES_PROGRAM = "609918-Open Enrollment";
export const GALE_ES_PROGRAM = "609933-Open Enrollment";
export const HAYT_ES_PROGRAM = "609976-Open Enrollment";
export const JORDAN_ES_PROGRAM = "609865-Open Enrollment";
export const KILMER_ES_PROGRAM = "610022-Open Enrollment";

export const MCPHERSON_ES_PROGRAM = "610070-610070-Magnet Cluster (International Baccalaureate Middle Years)";
export const WEST_RIDGE_ES_PROGRAM = "610542-Open Enrollment";
export const CALMECA_ES_PROGRAM = "610353-Open Enrollment (Dual Language)";
export const COOPER_ES_PROGRAM = "609867-Open Enrollment (Dual Language)";

export const AUDUBON_ES_PROGRAM = "609782-Magnet Cluster";
export const BELL_OPEN_ENROLLMENT_ES_PROGRAM = "609799-Open Enrollment";
export const BELL_REGIONAL_GIFTED_CENTER_ES_PROGRAM = "609799-Selective Enrollment (Regional Gifted Center)";
export const BLAINE_ES_PROGRAM = "609803-Magnet Cluster";
export const BUDLONG_ES_PROGRAM = "609817-Open Enrollment";

export const BURLEY_ES_PROGRAM = "609820-Magnet Cluster (Technology)";
export const CHAPPELL_ES_PROGRAM = "609852-Magnet Cluster (World Language)";

export const COONLEY_OPEN_ENROLLMENT_ES_PROGRAM = "609866-Open Enrollment";
export const COONLEY_REGIONAL_GIFTED_CENTER_ES_PROGRAM = "609866-Selective Enrollment (Regional Gifted Center)";
export const GREELEY_MAGNET_CLUSTER_ES_PROGRAM = "Magnet Cluster (World Language)";

export const GREELEY_REGIONAL_GIFTED_CENTER_ES_PROGRAM = "609850-Selective Enrollment (Regional Gifted Center for English Learners)";

export const HAMILTON_ES_PROGRAM = "609963-Magnet Cluster (Fine and Performing Arts)";

export const HAWTHORNE_ES_PROGRAM = "609974-Magnet (Scholastic Academy)";

export const INTER_AMERICAN_ES_PROGRAM = "610078-Magnet (Dual Language Immersion/Dual Language)";

export const JAHN_ES_PROGRAM = "610010-Magnet Cluster (World Language)";

export const LOCKE_GENERAL_EDUCATION_ES_PROGRAM = "610041-Open Enrollment";
export const LOCKE_MAGNET_CLUSTER_ES_PROGRAM = "610041-Magnet Cluster (International Baccalaureate Middle Years)";
export const PEIRCE_ES_PROGRAM = "610122-Magnet Cluster (International Baccalaureate Early and Middle Years)";

export const ARMSTRONG_G_ES_PROGRAM = "609779-Open Enrollment"

export const JAMIESON_ES_PROGRAM = "610011-Open Enrollment";
export const NETTELHORST_ES_PROGRAM = "610094-Magnet Cluster (Fine and Performing Arts)";
export const RAVENSWOOD_ES_PROGRAM = "610141-Magnet Cluster (Fine and Performing Arts)";
export const WATERS_ES_PROGRAM = "610220-Magnet Cluster (Fine and Performing Arts)";
export const CLINTON_ES_PROGRAM = "609859-General Education";
export const PETERSON_ES_PROGRAM = "610127-General Education";
export const ROGERS_ES_PROGRAM = "610147-General Education";
export const OGDEN_GENERAL_EDUCATION_ES_PROGRAM = "610101-General Education";
export const OGDEN_MAGNET_CLUSTER_ES_PROGRAM = "610101-Magnet Cluster (International Baccalaureate Middle Years)";
export const DISNEY_II_ES_PROGRAM = "610363-Magnet (Fine Arts/Technology)";
export const GOUDY_ES_PROGRAM = "609945-Magnet Cluster (Technology)"


export const ACERO_ZIZUMBO_ES_PROGRAM = "400079-General Education";
export const ACERO_TORRES_ES_PROGRAM = "400080-General Education";
export const ACERO_DE_LAS_CASAS_ES_PROGRAM = "400081-General Education";
export const ACERO_FUENTES_ES_PROGRAM = "400082-General Education";
export const ACERO_PAZ_ES_PROGRAM = "400083-General Education";
export const ACERO_TAMAYO_ES_PROGRAM = "400084-General Education";
export const ACERO_MARQUEZ_ES_PROGRAM = "400089-General Education";
export const ACERO_CISNEROS_ES_PROGRAM = "400101-General Education";
export const ACERO_IDAR_ES_PROGRAM = "400112-General Education";
export const ACERO_SANTIAGO_ES_PROGRAM = "400114-General Education";
export const ACERO_CLEMENTE_ES_PROGRAM = "400120-General Education";
export const ACERO_DE_LA_CRUZ_ES_PROGRAM = "400121-Fine & Performing Arts";

export const ACERO_ES_PROGRAMS = [
  ACERO_ZIZUMBO_ES_PROGRAM,
  ACERO_TORRES_ES_PROGRAM,
  ACERO_DE_LAS_CASAS_ES_PROGRAM,
  ACERO_FUENTES_ES_PROGRAM,
  ACERO_PAZ_ES_PROGRAM,
  ACERO_TAMAYO_ES_PROGRAM,
  ACERO_MARQUEZ_ES_PROGRAM,
  ACERO_CISNEROS_ES_PROGRAM,
  ACERO_IDAR_ES_PROGRAM,
  ACERO_SANTIAGO_ES_PROGRAM,
  ACERO_CLEMENTE_ES_PROGRAM,
  ACERO_DE_LA_CRUZ_ES_PROGRAM
];

export const CICS_AVALON_ES_PROGRAM = "400023-General Education";
export const CICS_BASIL_ES_PROGRAM = "400024-General Education";
export const CICS_BUCKTOWN_ES_PROGRAM = "400025-General Education";
export const CICS_IRVING_PARK_ES_PROGRAM = "400027-General Education";
export const CICS_PRAIRIE_ES_PROGRAM = "400028-General Education";
export const CICS_WASHINGTON_PARK_ES_PROGRAM = "400029-General Education";
export const CICS_WEST_BELDEN_ES_PROGRAM = "400030-General Education";
export const CICS_WRIGHTWOOD_ES_PROGRAM = "400031-General Education";

export const CICS_ES_PROGRAMS = [
  CICS_AVALON_ES_PROGRAM,
  CICS_BASIL_ES_PROGRAM,
  CICS_BUCKTOWN_ES_PROGRAM,
  CICS_IRVING_PARK_ES_PROGRAM,
  CICS_PRAIRIE_ES_PROGRAM,
  CICS_WASHINGTON_PARK_ES_PROGRAM,
  CICS_WEST_BELDEN_ES_PROGRAM,
  CICS_WRIGHTWOOD_ES_PROGRAM
]

// MS programs
export const ASPIRA_MS_PROGRAM = "400017-General Education";
export const MADERO_MS_PROGRAM = "610215-Open Enrollment";

export const NOBLE_COMER_MS_PROGRAM = "100001-Open Enrollment";
export const PERSPECTIVES_MS_PROGRAM = "100002-Open Enrollment";
export const ART_IN_MOTION_MS_PROGRAM = "100003-Open Enrollment";
export const INTRINSIC_MS_PROGRAM = "100004-Open Enrollment";

// joint HS / ES programs
// -----------------------
export const FOUNDATIONS_COLLEGE_PREP_JOINT_ES_HS_PROGRAM = "400171-General Education";
export const CHICAGO_VIRTUAL_GENERAL_EDUCATION_JOINT_ES_HS_PROGRAM = "400036-General Education";
export const CICS_LONGWOOD_GENERAL_EDUCATION_JOINT_ES_HS_PROGRAM = "400033-General Education";
export const CHICAGO_MATH_AND_SCIENCE_GENERAL_EDUCATION_JOINT_ES_HS_PROGRAM = "400035-General Education";
export const U_OF_C_WOODLAWN_GENERAL_EDUCATION_JOINT_ES_HS_PROGRAM = "400077-General Education";

export const CHICAGO_COLLEGIATE_GENERAL_EDUCATION_JOINT_ES_HS_PROGRAM = "400161-General Education";
export const CICS_CHICAGOQUEST_GENERAL_EDUCATION_JOINT_ES_HS_PROGRAM = "400113-General Education";

// Academic Centers (ES Program in HS school)
// ------------------------------------------
export const TAFT_ACADEMIC_CENTER_PROGRAM = "609734-Academic Center";
export const MORGAN_PARK_ACADEMIC_CENTER_PROGRAM = "609725-Academic Center";
export const KENWOOD_ACADEMIC_CENTER_PROGRAM = "609746-Academic Center";

// Dual/World Language Programs
// ----------------------------
export const AZUELA_LANGUAGE_PROGRAM = "610544-Open Enrollment (Dual Language Program)";
export const BARRY_LANGUAGE_PROGRAM = "609789-Open Enrollment (Dual Language Program)";
export const BATEMAN_LANGUAGE_PROGRAM = "609792-Open Enrollment (Dual Language Program)";
export const BELMONT_CRAGIN_LANGUAGE_PROGRAM = "609922-Open Enrollment (Dual Language Program)";
export const CALMECA_LANGUAGE_PROGRAM = "610353-Open Enrollment (Dual Language Program)";
export const CARSON_LANGUAGE_PROGRAM = "609842-Magnet Cluster (World Language Program)";
export const CHASE_LANGUAGE_PROGRAM = "609853-Magnet Cluster (World Language Program)";
export const COOPER_LANGUAUGE_PROGRAM = "609867-Open Enrollment (Dual Language Program)";
export const DARWIN_LANGUAGE_PROGRAM = "609875-Magnet Cluster (World Language Program)";
export const EDWARDS_LANGUAGE_PROGRAM = "609903-Magnet Cluster (Dual Language Program)";
export const HURLEY_LANGUAGE_PROGRAM = "610006-Magnet Cluster (Dual Language Program)";
export const MOOS_LANGUAGE_PROGRAM = "610076-Open Enrollment (Dual Language Program)";
export const MOZART_LANGUAGE_PROGRAM = "610088-Open Enrollment (Dual Language Program)";
export const SABIN_LANGUAGE_PROGRAM = "610342-Magnet (Dual Language Program)";
export const SPRY_LANGUAGE_PROGRAM = "610184-Magnet Cluster (World Language Program)";
export const STOWE_LANGUAGE_PROGRAM = "610192-Magnet Cluster (Dual Language Program)";
export const TALCOTT_LANGUAGE_PROGRAM = "610197-Magnet Cluster (Dual Language Program)";
export const TELPOCHCALLI_LANGUAGE_PROGRAM = "609921-Magnet Cluster (World Language Program)";
export const VOLTA_LANGUAGE_PROGRAM = "610209-Open Enrollment (Dual Language Program)";
export const VON_LINNE_LANGUAGE_PROGRAM = "610039-Open Enrollment (Dual Language Program)";
export const WHITTIER_LANGUAGE_PROGRAM = "610228-Magnet Cluster (World Language Program)";

// Groups of programs
// ============================================
export const CARNEGIE_ES_PROGRAMS: string[] = [
  CARNEGIE_REGIONAL_GIFTED_CENTER_ES_PROGRAM,
  CARNEGIE_MAGNET_CLUSTER_ES_PROGRAM
];

export const CPS_JOINT_ES_AND_HS_PROGRAM_IDS: string[] = [
  FOUNDATIONS_COLLEGE_PREP_JOINT_ES_HS_PROGRAM,
  CHICAGO_VIRTUAL_GENERAL_EDUCATION_JOINT_ES_HS_PROGRAM,
  CICS_LONGWOOD_GENERAL_EDUCATION_JOINT_ES_HS_PROGRAM,
  U_OF_C_WOODLAWN_GENERAL_EDUCATION_JOINT_ES_HS_PROGRAM,
  CHICAGO_MATH_AND_SCIENCE_GENERAL_EDUCATION_JOINT_ES_HS_PROGRAM,
  CHICAGO_COLLEGIATE_GENERAL_EDUCATION_JOINT_ES_HS_PROGRAM,
  CICS_CHICAGOQUEST_GENERAL_EDUCATION_JOINT_ES_HS_PROGRAM,
];

export const GROW_COMMUNITY_SCHOOL_ES_PROGRAMS: string[] = [
  AUDUBON_ES_PROGRAM,
  BELL_OPEN_ENROLLMENT_ES_PROGRAM,
  BELL_REGIONAL_GIFTED_CENTER_ES_PROGRAM,
  BLAINE_ES_PROGRAM,
  BUDLONG_ES_PROGRAM,
  BURLEY_ES_PROGRAM,
  CHAPPELL_ES_PROGRAM,
  COONLEY_REGIONAL_GIFTED_CENTER_ES_PROGRAM,
  COONLEY_OPEN_ENROLLMENT_ES_PROGRAM,
  GREELEY_MAGNET_CLUSTER_ES_PROGRAM,
  GREELEY_REGIONAL_GIFTED_CENTER_ES_PROGRAM,
  GREELEY_MAGNET_CLUSTER_ES_PROGRAM,
  HAMILTON_ES_PROGRAM,
  HAWTHORNE_ES_PROGRAM,
  INTER_AMERICAN_ES_PROGRAM,
  JAHN_ES_PROGRAM,
  JAMIESON_ES_PROGRAM,
  MCPHERSON_ES_PROGRAM,
  NETTELHORST_ES_PROGRAM,
  RAVENSWOOD_ES_PROGRAM,
  WATERS_ES_PROGRAM
];

export const AUSL_ES_PROGRAMS: string[] = [
  BRADWELL_ES_PROGRAM,
  CARTER_ES_PROGRAM,
  CASALS_ES_PROGRAM,
  CHALMERS_ES_PROGRAM,
  CURTIS_ES_PROGRAM,
  DENEEN_ES_PROGRAM,
  DEWEY_ES_PROGRAM,
  DULLES_ES_PROGRAM,
  DVORAK_ES_PROGRAM,
  FULLER_ES_PROGRAM,
  GRESHAM_ES_PROGRAM,
  HARVARD_ES_PROGRAM,
  HERZL_ES_PROGRAM,
  HOWE_ES_PROGRAM,
  JOHNSON_ES_PROGRAM,
  LEWIS_ES_PROGRAM,
  MARQUETTE_ES_PROGRAM,
  MCNAIR_ES_PROGRAM,
  MORTON_ES_PROGRAM,
  NATIONAL_TEACHERS_ACADEMY_GENERAL_EDUCATION_ES_PROGRAM,
  NATIONAL_TEACHERS_ACADEMY_REGIONAL_GIFTED_CENTER_ES_PROGRAM,
  OKEEFFE_ES_PROGRAM,
  PICCOLO_ES_PROGRAM,
  SHERMAN_ES_PROGRAM,
  STAGG_ES_PROGRAM,
  TARKINGTON_ES_PROGRAM,
  CHICAGO_ACADEMY_ES_PROGRAM,
];

export const LANGUAGE_ES_PROGRAMS = [
  AZUELA_LANGUAGE_PROGRAM,
  BARRY_LANGUAGE_PROGRAM,
  BATEMAN_LANGUAGE_PROGRAM,
  BELMONT_CRAGIN_LANGUAGE_PROGRAM,
  CALMECA_LANGUAGE_PROGRAM,
  CARSON_LANGUAGE_PROGRAM,
  CHASE_LANGUAGE_PROGRAM,
  COOPER_LANGUAUGE_PROGRAM,
  DARWIN_LANGUAGE_PROGRAM,
  EDWARDS_LANGUAGE_PROGRAM,
  //FIXME - Missing ERIE (doesn't show up in cps list of programs)
  //FIXME - Missing GLOBAL CITIZENSHIP (doesn't show up in cps list of programs)
  INTER_AMERICAN_ES_PROGRAM,
  MOOS_LANGUAGE_PROGRAM,
  MOZART_LANGUAGE_PROGRAM,
  //FIXME - Missing NAMASTE (doesn't show up in cps list of programs)
  SABIN_LANGUAGE_PROGRAM,
  SPRY_LANGUAGE_PROGRAM,
  STOWE_LANGUAGE_PROGRAM,
  TALCOTT_LANGUAGE_PROGRAM,
  TELPOCHCALLI_LANGUAGE_PROGRAM,
  VOLTA_LANGUAGE_PROGRAM,
  VON_LINNE_LANGUAGE_PROGRAM,
  WHITTIER_LANGUAGE_PROGRAM
];